<template>
  <div class="ai-friend-role-tag">
    <ConfigTable ref="ct" :searchConfig="searchConfig" :tableColumns="tableColumns" :tableData="list" :total="total"
      @change="loadData" @edit="edit" @add="add" @delete="deleteRow"></ConfigTable>
    <EditSystem ref="editDialog" @sure="callEdit"></EditSystem>
  </div>
</template>

<script>
import { Switch } from 'element-ui';
import { changeDate } from '../../../utils/filter';
import ConfigTable from '@/components/config-table';
import systemManageApi from '../../../api/systemManage';
import LongText from '../../aiFriendManage/roleManage/components/LongText.vue';
import EditSystem from '../components/EditSystem.vue';
import { statusOptions } from '../../config/system';

const searchConfig = [
  { type: 'input', placeholder: '输入配置名称', key: 'name' },
  // { type: 'select', placeholder: '选择配置类型', key: 'type', options: systemConfigOptions },
  { type: 'select', placeholder: '选择配置状态', key: 'status', options: statusOptions },
  { type: 'button', icon: 'search', placeholder: '搜索', key: 'search' },
  { type: 'button', icon: 'plus', placeholder: '新增', key: 'add' },
]

const tableColumns = [
  { name: 'ID', key: 'id', width: 220, fixed: 'fixed' },
  { name: '名称', key: 'name' },
  { name: '类型', key: 'type' },
  {
    name: '配置值', key: 'value', width: 220, component: LongText, props(value) {
      return { text: value }
    }
  },
  {
    name: '状态', key: 'status', component: Switch, props(value) {
      return { value: value === 1, disabled: true }
    }
  },
  { name: '修改账号', key: 'updateAct' },
  {
    name: '创建时间', key: 'createdAt', valueHandler: changeDate
  },
  {
    name: '更新时间', key: 'updatedAt', valueHandler: changeDate
  },
  { name: '操作', fixed: 'right', actions: ['edit', 'delete'] },
];

const AiChatBaseConfigType = 'aiChatBaseConfig'

export default {
  name: 'SystemConfigAiFriend',
  components: { ConfigTable, EditSystem },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {

  },
  mounted() {

  },
  methods: {
    async loadData(params) {
      try {
        const r = await systemManageApi.getSysConfigList({ ...params, type: AiChatBaseConfigType })
        const data = r.data
        this.total = data.total
        this.list = data.list
      } catch (error) {
        console.error('搜索ai角色标签失败：', error);
      }
    },
    add() {
      this.$refs.editDialog.open({ type: AiChatBaseConfigType })
    },
    edit(row) {
      this.$refs.editDialog.open({ ...row })
    },
    async deleteRow(row) {
      try {
        await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        await systemManageApi.delSysConfig({ id: row.id })
        this.$message.success('已删除')
        this.$refs.ct.search()
      } catch (error) {
        console.log(error);
      }
    },
    async callEdit(r) {
      try {
        console.log(r);
        await (r.isEdit ? systemManageApi.updateSysConfig(r.data) : systemManageApi.addSysConfig(r.data))
        this.$message.success(r.isEdit ? '更新成功' : '新增成功')
        this.$refs.editDialog.close()
        setTimeout(() => {
          this.$refs.ct.search()
        }, 200);
      } catch (error) {
        console.error('call edit error:', error);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ai-friend-role-tag {

  /deep/ .el-button {
    padding: 9px 15px;
  }

  /deep/ .el-image {
    width: 100px;
    height: 100px;

    img {
      object-fit: contain;
    }
  }
}
</style>